import { iconMapping } from 'customerPath/config'
import { isEmpty, set } from 'lodash'
import moment from 'moment'
import store from 'customerPath/store'
import { i18n } from '@/translations/i18n'

// Change Boolean Helper
export function changeBool(self, key) {
  self[key] = !self[key]
}

// Punct to slash
export const punctToSlash = str => str.replace(/\./g, '/').replace(process.env.VUE_APP_API_URL, '')

// object_type to type
export function objectTypeToType(object_type) {
  // if object_type is combined parent.children object, return only last children
  return object_type.indexOf('.') > -1 ? object_type.split('.').pop() : object_type
}

export function toggleBodyClass(className, force_state) {
  const el = document.body

  if (force_state) {
    el.classList.add(className)
  } else if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}

export function setBodyBackground(background) {
  const style = document.createElement('style')
  style.innerHTML = '.v-main__wrap::after {' + `background-image: url(${background});` + '}'
  const ref = document.querySelector('script')
  ref.parentNode.insertBefore(style, ref)
}

/* Parse social media source to matching icon */

export function getSocialMediaIconForSource(source) {
  return iconMapping(source) || iconMapping('webnews_default')
}

/* Remove unwanted editor content for being able to line-clamp content. */
export function fixEditorContentForLineClamp(text) {
  /*
   Since editor content is returned as multiple divs on first level, line clamp cannot work.
   So we have to strip unwanted content from news teaser, which comes trough the mentioning editor.
   */

  if (!document) {
    return text
  }

  // Editor is building paragraphs sometimes by an div only containing an br
  // - we have to replace this by doubled br
  const doubleBrInsteadOfDivFollowedByBr = text.replace(/<div><br><\/div>/ig, '<div><br /><br />')

  // We need a temporary new DOM element to be able to use DOM selectors on it
  const tempContainer = document.createElement('p')

  // Now we set the prepared news teaser value as innerHTML of the temporary DOM element
  tempContainer.innerHTML = doubleBrInsteadOfDivFollowedByBr

  // Now we iterate over all divs in element and are unwrapping their content by moving it one level up
  const elements = tempContainer.querySelectorAll('div')
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i]
    // get the element's parent node
    const parent = element.parentNode
    // move all children out of the element
    while (element.firstChild) parent.insertBefore(element.firstChild, element)
    // remove the empty element
    parent.removeChild(element)
  }

  // Remove iframes
  tempContainer.querySelectorAll('iframe').forEach(e => e.remove())

  // Now we destroy the temp element again to free DOM and return the value
  const usableContent = tempContainer.innerHTML
  tempContainer.remove()
  return usableContent
}

export const europeChars = 'A-Za-zÁÀȦÂÄǞǍĂĀÃÅǺǼǢĆĊĈČĎḌḐḒÉÈĖÊËĚĔĒẼE̊ẸǴĠĜǦĞG̃ĢĤḤáàȧâäǟǎăāãåǻǽǣćċĉčďḍḑḓéèėêëěĕēẽe̊ẹǵġĝǧğg̃ģĥḥÍÌİÎÏǏĬĪĨỊĴĶǨĹĻĽĿḼM̂M̄ʼNŃN̂ṄN̈ŇN̄ÑŅṊÓÒȮȰÔÖȪǑŎŌÕȬŐỌǾƠíìiîïǐĭīĩịĵķǩĺļľŀḽm̂m̄ŉńn̂ṅn̈ňn̄ñņṋóòôȯȱöȫǒŏōõȭőọǿơP̄ŔŘŖŚŜṠŠȘṢŤȚṬṰÚÙÛÜǓŬŪŨŰŮỤẂẀŴẄÝỲŶŸȲỸŹŻŽẒǮp̄ŕřŗśŝṡšşṣťțṭṱúùûüǔŭūũűůụẃẁŵẅýỳŷÿȳỹźżžẓǯßœŒçÇ'

export async function timelineItems($el) {
  const timeline = $el
  const elements = timeline.querySelectorAll('.v-timeline-item')
  const posTop = { left: 0, right: 24 }
  let posEnd = 0
  for (let x = 0; x < elements.length; x++) {
    const column = posTop.left <= posTop.right ? 'left' : 'right'
    elements[x].style.top = posTop[column] + 'px'
    elements[x].classList.remove('left', 'right')
    elements[x].classList.add(column)
    posTop[column] = elements[x].getBoundingClientRect().bottom
    posEnd = elements[x].getBoundingClientRect().bottom > posEnd ? elements[x].getBoundingClientRect().bottom : posEnd
  }
  const height = posEnd - elements[0].getBoundingClientRect().top
  timeline.style.height = height + 'px'
}

export const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,18}(:[0-9]{1,5})?(\/.*)?$/

export const removeWords = (str, arr) => {
  /* Remove all words in given array from string. */

  return arr.reduce((acc, val) => {
    const regex = new RegExp(`${val}([-_\\/]?)`, 'gi')
    return acc.replace(regex, '').replace(/\s\s+/g, ' ').trim()
  }, str)
}

export const insertEmoji = (emoji, vm, targetElementString, testRun = {}) => {
  /**
   * Insert selected Emoji to element.
   * @param {emoji} string - ascii string representing the selected emoji
   * @param {vm} object - the vm calling the function, basically 'this' from component view
   * @param {targetElementString} string - which element gets updated - as nestedObjectString without 'this.'
   * @param {testRun} object - jest only: if given it should contain test data for cursorPosition and initial value
   *
   * @example - targetElementString
   * If this.message is needed in component, targetElementString is 'message'
   * If you need to address this.$refs.message from component, the passed string is '$refs.message'
   *
   * @example - testRun
   * {
   *   @param cursorPosition integer
   *   @param initialValue string
   * }
   */
  if (isEmpty(testRun)) {
    const textarea = vm.$refs.message.$el.querySelector('textarea')
    const cursorPosition = textarea.selectionStart
    const start = textarea.value.substring(0, cursorPosition)
    const end = textarea.value.substring(textarea.selectionEnd)
    set(vm, targetElementString, `${start}${emoji.data}${end}`)
    textarea.focus()
    vm.$nextTick(() => {
      textarea.selectionEnd = cursorPosition + emoji.data.length
      vm.emojiOpen = false
    })
  } else {
    // In testCase only the updated targetElement is testable
    // TODO - figure out how to test more of it and if possible dont have an else block for jest stuff
    const cursorPosition = testRun.cursorPosition || 0
    const initialString = testRun.initialString || ''
    const start = initialString.substring(0, cursorPosition)
    const end = initialString.substring(cursorPosition)
    set(vm, targetElementString, `${start}${emoji.data}${end}`)
  }
}

export const wrapIframes = content => {
  /* Wraps iframes in content string with <div class="iframe-wrapper"></div> element. */
  const wrapperClass = content.indexOf('no-landscape') > -1 ? 'iframe-wrapper' : 'iframe-wrapper video'
  // remove wrapping paragraphs from editor
  content = content.replace(/<p><iframe/ig, '<iframe')
  content = content.replace(/<\/iframe><\/p>/ig, '</iframe>')
  // wrap with own element
  content = content.replace(/<iframe/ig, '<div class="' + wrapperClass + '"><iframe')
  content = content.replace(/<\/iframe>/ig, '</iframe></div>')
  // return modified content
  return content
}

export const removeScripts = (content, id) => {
  /* removeScripts from editor */
  if (content.indexOf('<script') !== -1) {
    const divId = `scripts-${id}`
    // remove scripts from content
    content = content.replace(/<script[^>]*>.*?<\/script>/gis, '')
    // wrap content with unique identifier
    content = `<div id='${divId}'>${content}</div>`
  }
  // remove empty paragraphs
  content = content.replace(/<p>\s<\/p>/g, '')
  content = content.replace(/<p>&nbsp;<\/p>/g, '')
  return content
}

export const getScripts = (content, id) => {
  /* getScripts from editor */
  if (content.indexOf('<script') !== -1) {
    // gets scripts as array
    const scriptTags = content.match(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi)
    // return scripts
    return scriptTags
  }
  return []
}

export const formatDayTime = time => {
  return moment(time).format('HH:mm')
}

export const formatDate = date => {
  return moment(date).format('DD.MM.YYYY')
}

export const isInCustomerProfileOptions = (type, value) => {
  const apiSettings = store && store.state && store.state.auth && store.state.auth.settings
  /* Check if value is in apiSettings.profile_options.includedProfile<type> object */

  if (apiSettings && apiSettings.profile_options) {
    const configObject = apiSettings.profile_options[`included_profile_${type.toLowerCase()}`]
    return configObject && Array.isArray(configObject) && configObject.includes(value)
  }
}

export const sectionComponentList = (profileSections, components) => {
  /* Build a valid component list for profile sections out of config array and loaded components in order of config.
   *
   * In case of 'payments' is listed section, but subscriptions not, the subscriptions component still has to be
   * used, so it will be added to valid list.
   * */

  const sectionModules = []
  profileSections.forEach(module => {
    // If section is 'payments' remap to 'subscription'
    module = module === 'payments' ? 'subscriptions' : module

    // if component list is given, check for valid components
    if (components && !components.includes(module)) {
      module = null
    }
    // If module is not in list, add it
    if (module && sectionModules.indexOf(module) === -1) {
      sectionModules.push(module)
    }
  })

  return sectionModules
}

export const displayUserName = obj => {
  /* Return fullname if given, otherwise concatenated first + lastname.
   *
   * Since API provides for some endpoints the one and for other the second variant of param namings, we handle params
   * in regular variant (e.g. fullname) and as well in kebab case variant(e.g. full_name).
   * */

  const firstname = obj.firstname || obj.first_name || ''
  const lastname = obj.lastname || obj.last_name || ''
  const fullname = obj.fullname || obj.full_name || ''
  return fullname || `${firstname} ${lastname}`.trim()
}

export const successStatusTranslation = (type, action) => {
  return `success_response.${type}.${action}`
}

export const getCustomFieldsList = (customSections, key) => {
  customSections.forEach(customField => {
    customField.fields.forEach(field => {
      if (field.type === 'file') {
        const fileKeys = []
        field.value.forEach(fileKey => {
          fileKeys.push(fileKey.key)
        })
        key[field.id] = { file: fileKeys }
      } else {
        key[field.id] = field.value
      }
    })
  })
}

export const changeEventOnAutofillFields = () => {

  // mock input change event for autofill fields
  setInterval(
    () => {
      document.querySelectorAll('input').forEach(elem => {
        if (elem && elem.matches(':-webkit-autofill')) {
          const parent = elem.parentNode
          if (parent) {
            parent.classList.add('v-input--is-label-active')
            if (parent.querySelector('label')) {
              parent.querySelector('label').classList.add('v-label--active')
            }
          }
        }
      })
    },
    200,
  )
}

export const showAGBCheckbox = transObject => {
  return Boolean(transObject && transObject.agb_html && transObject.agb_html.label)
}

export const initGTM = gtm => {
  if (gtm && gtm.trackEvent) {
    const activeCategories = window.activeCategories || []
    const activeServices = window.activeServices || []
    gtm.trackEvent({
      'event': 'cmpInit',
      'cmpCategories': activeCategories,
      'cmpServices': activeServices,
    })
  }
}

export const exceptionalCustomers = _ => {
  const customer = process.env.CUSTOMER || process.env.customer

  return [
    'motelone',
    'sweettec',
  ].includes(customer)
}

export const isCustomer = customerString => {
  const customer = process.env.CUSTOMER || process.env.customer
  return customer === customerString
}

export const isKeyCloakActive = () => {
  return Boolean(process.env.VUE_APP_KEYCLOAK_INSTANCE)
}

export const getPossessive = name => {
  const language = i18n.locale.substring(0, 2)
  if (language === 'de') {
    // In German, usually no apostrophe. But if name ends with 's', 'x', or 'z', add apostrophe.
    const lower = name.toLowerCase()
    if (/[sxz]$/.test(lower)) {
      return `${name}'`
    } else {
      return `${name}s`
    }
  }
  // Fallback - In English and other languages, always use apostrophe-s, unless name already ends with 's'
  return name.endsWith('s') ? `${name}'` : `${name}'s`
}

const iso6391LanguagesWithCountry = {
  af: { name: 'Afrikaans', country: 'ZA' },
  am: { name: 'Amharisch', country: 'ET' },
  an: { name: 'Aragonisch', country: 'ES' },
  ar: { name: 'Arabisch', country: 'SA' },
  as: { name: 'Assamesisch', country: 'IN' },
  az: { name: 'Aserbaidschanisch', country: 'AZ' },
  ba: { name: 'Baschkirisch', country: 'RU' },
  be: { name: 'Belarussisch', country: 'BY' },
  bg: { name: 'Bulgarisch', country: 'BG' },
  bi: { name: 'Bislama', country: 'VU' },
  bm: { name: 'Bambara', country: 'ML' },
  bn: { name: 'Bengalisch', country: 'BD' },
  bo: { name: 'Tibetisch', country: 'CN' },
  br: { name: 'Bretonisch', country: 'FR' },
  bs: { name: 'Bosnisch', country: 'BA' },
  ca: { name: 'Katalanisch', country: 'ES' },
  ce: { name: 'Tschetschenisch', country: 'RU' },
  ch: { name: 'Chamorro', country: 'GU' },
  co: { name: 'Korsisch', country: 'FR' },
  cs: { name: 'Tschechisch', country: 'CZ' },
  cv: { name: 'Tscherkassisch', country: 'RU' },
  cy: { name: 'Walisisch', country: 'GB' },
  da: { name: 'Dänisch', country: 'DK' },
  de: { name: 'Deutsch', country: 'DE' },
  dv: { name: 'Divehi', country: 'MV' },
  dz: { name: 'Dzongkha', country: 'BT' },
  el: { name: 'Griechisch', country: 'GR' },
  en: { name: 'Englisch', country: 'GB' },
  es: { name: 'Spanisch', country: 'ES' },
  et: { name: 'Estnisch', country: 'EE' },
  eu: { name: 'Baskisch', country: 'ES' },
  fa: { name: 'Persisch', country: 'IR' },
  fi: { name: 'Finnisch', country: 'FI' },
  fj: { name: 'Fidschi', country: 'FJ' },
  fo: { name: 'Färöisch', country: 'FO' },
  fr: { name: 'Französisch', country: 'FR' },
  fy: { name: 'Westfriesisch', country: 'NL' },
  ga: { name: 'Irisch', country: 'IE' },
  gd: { name: 'Schottisch-Gälisch', country: 'GB' },
  gl: { name: 'Galicisch', country: 'ES' },
  gn: { name: 'Guaraní', country: 'PY' },
  gu: { name: 'Gujarati', country: 'IN' },
  gv: { name: 'Manx', country: 'GB' },
  he: { name: 'Hebräisch', country: 'IL' },
  hi: { name: 'Hindi', country: 'IN' },
  ho: { name: 'Hiri Motu', country: 'PG' },
  hr: { name: 'Kroatisch', country: 'HR' },
  ht: { name: 'Haitianisch', country: 'HT' },
  hu: { name: 'Ungarisch', country: 'HU' },
  hy: { name: 'Armenisch', country: 'AM' },
  hz: { name: 'Herero', country: 'NA' },
  id: { name: 'Indonesisch', country: 'ID' },
  ig: { name: 'Igbo', country: 'NG' },
  ii: { name: 'Sichuan Yi', country: 'CN' },
  ik: { name: 'Inupiaq', country: 'US' },
  is: { name: 'Isländisch', country: 'IS' },
  it: { name: 'Italienisch', country: 'IT' },
  iu: { name: 'Inuktitut', country: 'CA' },
  ja: { name: 'Japanisch', country: 'JP' },
  jv: { name: 'Javanisch', country: 'ID' },
  ka: { name: 'Georgisch', country: 'GE' },
  kg: { name: 'Kongo', country: 'CG' },
  kk: { name: 'Kasachisch', country: 'KZ' },
  km: { name: 'Khmer', country: 'KH' },
  ki: { name: 'Kikuyu', country: 'KE' },
  kn: { name: 'Kannada', country: 'IN' },
  ko: { name: 'Koreanisch', country: 'KR' },
  ks: { name: 'Kaschmirisch', country: 'IN' },
  kv: { name: 'Komi', country: 'RU' },
  kw: { name: 'Kornisch', country: 'GB' },
  ky: { name: 'Kirgisisch', country: 'KG' },
  lb: { name: 'Luxemburgisch', country: 'LU' },
  lg: { name: 'Luganda', country: 'UG' },
  li: { name: 'Limburgisch', country: 'NL' },
  ln: { name: 'Lingala', country: 'CD' },
  lo: { name: 'Lao', country: 'LA' },
  lt: { name: 'Litauisch', country: 'LT' },
  lv: { name: 'Lettisch', country: 'LV' },
  mg: { name: 'Malagassi', country: 'MG' },
  mh: { name: 'Marshallesisch', country: 'MH' },
  mi: { name: 'Maori', country: 'NZ' },
  mk: { name: 'Mazedonisch', country: 'MK' },
  ml: { name: 'Malayalam', country: 'IN' },
  mn: { name: 'Mongolisch', country: 'MN' },
  mr: { name: 'Marathi', country: 'IN' },
  ms: { name: 'Malaiisch', country: 'MY' },
  mt: { name: 'Maltesisch', country: 'MT' },
  my: { name: 'Birmanisch', country: 'MM' },
  na: { name: 'Nauruisch', country: 'NR' },
  nb: { name: 'Norwegisch Bokmål', country: 'NO' },
  nd: { name: 'Nördliches Ndebele', country: 'ZW' },
  ne: { name: 'Nepali', country: 'NP' },
  ng: { name: 'Ndonga', country: 'NA' },
  nl: { name: 'Niederländisch', country: 'NL' },
  nn: { name: 'Norwegisch Nynorsk', country: 'NO' },
  no: { name: 'Norwegisch', country: 'NO' },
  nr: { name: 'Südliches Ndebele', country: 'ZA' },
  nv: { name: 'Navajo', country: 'US' },
  ny: { name: 'Nyanja', country: 'MW' },
  oc: { name: 'Okzitanisch', country: 'FR' },
  om: { name: 'Oromo', country: 'ET' },
  or: { name: 'Oriya', country: 'IN' },
  os: { name: 'Ossetisch', country: 'RU' },
  pa: { name: 'Pandschabi', country: 'IN' },
  pl: { name: 'Polnisch', country: 'PL' },
  ps: { name: 'Paschtu', country: 'AF' },
  pt: { name: 'Portugiesisch', country: 'PT' },
  qu: { name: 'Quechua', country: 'PE' },
  rm: { name: 'Rätoromanisch', country: 'CH' },
  rn: { name: 'Kirundi', country: 'BI' },
  ro: { name: 'Rumänisch', country: 'RO' },
  ru: { name: 'Russisch', country: 'RU' },
  rw: { name: 'Kinyarwanda', country: 'RW' },
  sc: { name: 'Sardisch', country: 'IT' },
  sd: { name: 'Sindhi', country: 'PK' },
  se: { name: 'Nordsamisch', country: 'NO' },
  sg: { name: 'Sango', country: 'CF' },
  si: { name: 'Singhalesisch', country: 'LK' },
  sk: { name: 'Slowakisch', country: 'SK' },
  sl: { name: 'Slowenisch', country: 'SI' },
  sm: { name: 'Samoanisch', country: 'WS' },
  sn: { name: 'Shona', country: 'ZW' },
  so: { name: 'Somali', country: 'SO' },
  sq: { name: 'Albanisch', country: 'AL' },
  sr: { name: 'Serbisch', country: 'RS' },
  ss: { name: 'Swazi', country: 'SZ' },
  st: { name: 'Sesotho', country: 'LS' },
  su: { name: 'Sundanesisch', country: 'ID' },
  sv: { name: 'Schwedisch', country: 'SE' },
  sw: { name: 'Swahili', country: 'TZ' },
  ta: { name: 'Tamil', country: 'IN' },
  te: { name: 'Telugu', country: 'IN' },
  tg: { name: 'Tadschikisch', country: 'TJ' },
  th: { name: 'Thailändisch', country: 'TH' },
  ti: { name: 'Tigrinya', country: 'ER' },
  tk: { name: 'Turkmenisch', country: 'TM' },
  tl: { name: 'Tagalog', country: 'PH' },
  tn: { name: 'Setswana', country: 'BW' },
  to: { name: 'Tongaisch', country: 'TO' },
  tr: { name: 'Türkisch', country: 'TR' },
  ts: { name: 'Tsonga', country: 'ZA' },
  tt: { name: 'Tatarisch', country: 'RU' },
  tw: { name: 'Twi', country: 'GH' },
  ty: { name: 'Tahitisch', country: 'PF' },
  ug: { name: 'Uigurisch', country: 'CN' },
  uk: { name: 'Ukrainisch', country: 'UA' },
  ur: { name: 'Urdu', country: 'PK' },
  uz: { name: 'Usbekisch', country: 'UZ' },
  ve: { name: 'Venda', country: 'ZA' },
  vi: { name: 'Vietnamesisch', country: 'VN' },
  wa: { name: 'Wallonisch', country: 'BE' },
  wo: { name: 'Wolof', country: 'SN' },
  xh: { name: 'Xhosa', country: 'ZA' },
  yi: { name: 'Jiddisch', country: 'DE' },
  yo: { name: 'Yoruba', country: 'NG' },
  za: { name: 'Zhuang', country: 'CN' },
  zh: { name: 'Chinesisch', country: 'CN' },
  zu: { name: 'Zulu', country: 'ZA' },
}


export const langToCountry = lang => {
  return iso6391LanguagesWithCountry[lang] ? iso6391LanguagesWithCountry[lang].country : null
}
